import {
  Box,
  Flex,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Text
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import ReactApexChart from 'react-apexcharts'

import {
  IGraphicResponse,
  ILineParams
} from '@base/@types/providers/Kpi/SalesProvider'

import {
  getMarginSeries,
  getSalesSeries,
  marginOptions,
  salesOptions
} from './ParseInfos/parseSalesChartInfos'

interface IParseParamsModalOrGraphic {
  isClickLine: boolean
  value?: string
  lineData?: ILineParams
}
interface IKpiSalesGraphicProps {
  data: IGraphicResponse
  getChartData: ({
    lineData,
    isClickLine,
    value
  }: IParseParamsModalOrGraphic) => void
  updateRealOrBtleoState: (type: string) => void
  realOrBtleoState: string
  stateOption?: string
}

const KpiSalesGraphic: FC<IKpiSalesGraphicProps> = ({
  data,
  getChartData,
  updateRealOrBtleoState,
  realOrBtleoState,
  stateOption = '2'
}) => {
  const [salesRadioValue, setSalesRadioValue] = useState(stateOption)
  const [marginRadioValue, setMarginRadioValue] = useState(stateOption)

  const handleSetRealOrBtleoValue = (value: string) => {
    getChartData({ isClickLine: true, value })
    updateRealOrBtleoState(value)
  }

  return (
    <Box borderTop="1px solid #e3e3e3">
      <Flex
        flexDir="column"
        alignItems="center"
        background="gray.100"
        paddingTop={2}
        paddingBottom={0}
      >
        <RadioGroup
          onChange={handleSetRealOrBtleoValue}
          value={realOrBtleoState}
        >
          <Stack spacing={8} direction="row">
            <Radio size="sm" borderColor="blackAlpha.300" value="1">
              Real
            </Radio>

            <Radio size="sm" borderColor="blackAlpha.300" value="2">
              BTLeo
            </Radio>
          </Stack>
        </RadioGroup>
      </Flex>

      <Grid templateColumns="45% 55% 1fr" background="gray.100" minW={1200}>
        <Box>
          <Flex alignItems="center" flexDir="column">
            <Text fontSize={14} fontWeight="bold" marginBottom={2}>
              Vendas
            </Text>

            <Flex marginBottom={1}>
              <RadioGroup onChange={setSalesRadioValue} value={salesRadioValue}>
                <Stack spacing={8} direction="row">
                  <Radio size="sm" borderColor="blackAlpha.300" value="1">
                    Acumulado
                  </Radio>

                  <Radio size="sm" borderColor="blackAlpha.300" value="2">
                    Mês a Mês
                  </Radio>
                </Stack>
              </RadioGroup>
            </Flex>
          </Flex>

          <ReactApexChart
            options={salesOptions}
            series={getSalesSeries(data.vendas, salesRadioValue)}
            width="100%"
            height="240px"
          />
        </Box>

        <Box>
          <Flex alignItems="center" flexDir="column">
            <Text fontSize={14} fontWeight="bold" marginBottom={2}>
              Margem
            </Text>

            <Flex marginBottom={1}>
              <RadioGroup
                onChange={setMarginRadioValue}
                value={marginRadioValue}
              >
                <Stack spacing={8} direction="row">
                  <Radio size="sm" borderColor="blackAlpha.300" value="1">
                    Acumulado
                  </Radio>

                  <Radio size="sm" borderColor="blackAlpha.300" value="2">
                    Mês a Mês
                  </Radio>
                </Stack>
              </RadioGroup>
            </Flex>
          </Flex>

          <ReactApexChart
            options={marginOptions}
            series={getMarginSeries(data.margem, marginRadioValue)}
            width="100%"
            height="240px"
          />
        </Box>
      </Grid>
    </Box>
  )
}

export default KpiSalesGraphic
